import {
  AsyncGridColumns,
  ColumnChipList,
  ColumnLink,
} from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.full name',
    field: 'name',
    sortable: false,
    minWidth: 240,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.name}</ColumnLink>,
  },
  {
    headerName: 'column.contact phone',
    field: 'phone',
    sortable: false,
    minWidth: 240,
  },
  {
    headerName: 'column.e-mail',
    field: 'email',
    sortable: false,
    minWidth: 240,
  },
  {
    headerName: 'column.time zone',
    field: 'timezone',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.regions',
    field: 'regions',
    sortable: false,
    flex: 1,
    renderCell: ({ value }) => <ColumnChipList items={value} />,
  },
  {
    headerName: 'column.roles',
    field: 'rolesIds',
    sortable: false,
    flex: 1,
    renderCell: ({ value }) => <ColumnChipList items={value} />,
  },
]
